import { useEffect, useState } from 'react';
import {
  FinancialAccountNode,
  OrgNode,
} from '../../../services/orgs/interfaces';
import { crawlHierarchy } from '../services/crawlHierarchy';
import { StripeEnv } from '../../../util/enums';
import { extractErrorMessage } from '../../../util/errorMessage';

export default function useFinancialAccountData({
  org,
  orgDataIsFinished,
  financialAccountRoots,
  financialAccountRootsAreFinished,
  provider,
  stripeEnv,
  payableOrgId,
}: {
  org?: OrgNode;
  orgDataIsFinished: boolean;
  financialAccountRoots?: FinancialAccountNode[];
  financialAccountRootsAreFinished: boolean;
  provider: VaultProvider;
  stripeEnv: StripeEnv;
  payableOrgId?: string;
}): {
  financialAccountNode?: FinancialAccountNode;
  submittedOnYourBehalf?: boolean;
  errorMessage?: string;
  isFinished: boolean;
} {
  const [financialAccountNode, setFinancialAccountNode] =
    useState<FinancialAccountNode>();
  const [submittedOnYourBehalf, setSubmittedOnYourBehalf] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    const gatherData = async (): Promise<void> => {
      if (
        (orgDataIsFinished && org === undefined) ||
        (financialAccountRootsAreFinished &&
          financialAccountRoots === undefined)
      ) {
        setIsFinished(true);
      } else if (
        financialAccountNode === undefined &&
        submittedOnYourBehalf === undefined &&
        org !== undefined &&
        orgDataIsFinished &&
        financialAccountRoots !== undefined &&
        financialAccountRootsAreFinished
      ) {
        try {
          const crawledData =
            (await crawlHierarchy(
              org,
              financialAccountRoots,
              provider,
              stripeEnv,
              payableOrgId,
            )) || undefined;
          setFinancialAccountNode(crawledData?.financialAccount);
          setSubmittedOnYourBehalf(crawledData?.submittedOnYourBehalf);
        } catch (e) {
          setErrorMessage(extractErrorMessage(e));
        } finally {
          setIsFinished(true);
        }
      }
    };
    gatherData();
  });

  return {
    financialAccountNode,
    submittedOnYourBehalf,
    errorMessage,
    isFinished,
  };
}
